import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Redirect, Switch, BrowserRouter } from "react-router-dom";
import { store } from "./redux/store";
import { DefaultRoute, PrivateRoute } from './components/Generic/GenerateRoutes/generateRoutes';
import { ThemeProvider } from '@material-ui/core/styles';
import Header from "./components/Generic/Header/header";
import theme from './theme';
import './global.scss';
import NotifierActions from "./redux/notifier/actions";
import Notifier, {notifierVariants} from "./components/Generic/Notifier/NotifierCustomizable";
import CustomSnackbar from "./components/Generic/customSnackbar/customSnackbar";

class App extends React.Component {

  constructor() {
    super();
    console.info("---------PRODUZIONE!---------")
  }


  closeNotifier = () => {
    this.setState({...this.state, open: false});
  }

  handleWindowClose(){
    localStorage.removeItem("filters");
};

  componentDidMount() {
    window.addEventListener("beforeunload", (ev) => 
{  
    ev.preventDefault();
    return this.handleWindowClose();
});
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <BrowserRouter basename="/pml-fe/">
            <Header />
            <Switch>
              <DefaultRoute exact path="/login" importRoute="login" />
              {process.env.REACT_APP_DISABLE_LOGINOLD !== 'true' && <DefaultRoute exact path="/loginOld" importRoute="loginOld" />}
              <DefaultRoute exact path="/loginSAML" importRoute="loginSAML" />
              <PrivateRoute exact path="/materialsheets" importRoute="materialSheetList" />
              <PrivateRoute exact path="/materialsheets/:uuid" importRoute="materialSheetDetail" />
              <PrivateRoute exact path="/sparepartsdetails/:uuid" importRoute="sparePartsDetails"/>
              <PrivateRoute exact path="/orders" importRoute="ListaOrdineFornitore" />
              <PrivateRoute exact path="/newOrders" importRoute="NuovoOrdineFornitore" />
              <PrivateRoute exact path="/newEM" importRoute="NuovaEntrataMerci" />
              <PrivateRoute exact path="/spareparts" importRoute="spareParts" />
              <PrivateRoute exact path="/palietralicci" importRoute="PaliTralicci" />
              <PrivateRoute exact path="/palietralicci/:uuid" importRoute="PaliTralicciInformazioni" />
              <PrivateRoute exact path="/anagraficaseriali" importRoute="AnagraficaSeriali" />
              <PrivateRoute exact path="/dismissionreport" importRoute="DismissionReport" />
              <PrivateRoute exact path="/failurereport" importRoute="FailureReport" />
              <PrivateRoute exact path="/giacenzaMagazzino" importRoute="GiacenzaMagazzino" />
              <PrivateRoute exact path="/dashboardAdmin" importRoute="DashboardAdmin" />
              <PrivateRoute exact path="/surveyDitta" importRoute="SurveyDitta" />
              <PrivateRoute exact path="/surveyAdmin" importRoute="SurveyAdmin" />
              <PrivateRoute exact path="/navigationdeny" importRoute="NavigationDeny" />
              <PrivateRoute exact path="/advancedSearch" importRoute="AdvancedSearch" />              
              <PrivateRoute exact path="/consolemonitoring" importRoute="ConsoleMonitoring" />      
              <PrivateRoute exact path="/buoniPrelievoList" importRoute="BuoniPrelievoList" />
              <PrivateRoute exact path="/buoniPrelievoExport" importRoute="BuoniPrelievoExport" />
              <PrivateRoute exact path="/buoniPrelievoList/:uuid" importRoute="BuonoPrelievoDetail" /> 
              <PrivateRoute exact path="/buoniPrelievoMaterials/:uuid/:formUuid" importRoute="BuonoPrelievoMaterialDetail" />       
              <Redirect exact from="/" to="/login" />
            </Switch>

          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("root"));
